'use strict'
module.exports = `
message RPC {
  repeated SubOpts subscriptions = 1;
  repeated Message msgs = 2;

  message SubOpts {
    optional bool subscribe = 1; // subscribe or unsubcribe
    optional string topicCID = 2;
  }

  message Message {
    optional string from = 1;
    optional bytes data = 2;
    optional bytes seqno = 3;
    repeated string topicCIDs = 4; // CID of topic descriptor object
  }
}`



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-floodsub/src/message/rpc.proto.js
// module id = 613
// module chunks = 0